import { IRoute } from "../../../common/helpers/routesMapper";
import { seo } from "../../../common/helpers/seo";
import { getRecentPlans } from "../../store/recentPlans/actions";

import Home from "./lazy";

export default {
    component: Home,
    loadData: ({ dispatch }: any) => {
        return dispatch(getRecentPlans());
    },
    renderSeo: (store: any, allMessage: any, lang: string) => {
        return seo({ title: `Musicators - ${allMessage.slogen}`, allMessage, lang });
    },
} satisfies IRoute;
